export const SNOWPLOW_COOKIE_NAME_PREFIX = 'wca_spid';

export const extractSnowplowCookieValues = cookies => {
  const cookieKey = cookies ? Object.keys(cookies).find(key => key.startsWith(SNOWPLOW_COOKIE_NAME_PREFIX)) : undefined;
  const cookieValue = cookieKey ? cookies?.[cookieKey] : undefined;

  if (typeof cookieValue !== 'string' || !cookieValue) {
    return { domainUserId: undefined, domainSessionId: undefined };
  }

  const parts = cookieValue.split('.');

  return {
    domainUserId: parts[0] || undefined,
    domainSessionId: parts[5] || undefined,
  };
};

export default extractSnowplowCookieValues;
